const format = (raw) => {
  if (typeof raw === "string") {
    return raw;
  }
  const { port, query, protocol: rawProtocol, hostname, pathname } = raw;
  let q;
  let href = "";
  if (query) {
    q = Object.entries(query).map(([k, v]) => {
      if (Array.isArray(v)) {
        return v.map((lq) => `${k}=${encodeURIComponent(lq)}`).join("&");
      }
      return v === null || v === void 0 ? `${k}` : `${k}=${encodeURIComponent(v)}`;
    }).join("&");
  }
  if (rawProtocol) {
    const protocol = rawProtocol.endsWith(":") ? rawProtocol : `${rawProtocol}:`;
    href = `${protocol}//`;
  }
  if (hostname) {
    href = `${href}${hostname}`;
  }
  if (port) {
    href = `${href}:${port}`;
  }
  if (pathname) {
    href = `${href}${pathname}`;
  }
  return `${encodeURI(href)}${q ? `?${q}` : ""}`;
};

export { format };
//# sourceMappingURL=format.mjs.map
